module.exports = __webpack_public_path__ + "img/11825376_L.82c3b7bb.png";